import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { get_proformaList_action, insert_update_proforma_action, download_proforma_action } from "../../../actions/accounts_action/proforma_action/proforma_action";
import { downloadReport, responseError, role_id } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import Header from "../../../common_components/Header";
import moment from "moment";
import Footer from "../../../common_components/Footer";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import MobileHeader from "../../../common_components/mobileHeader";

class ProformaList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      user_id: "",
      proforma_id: "",
      ApplicantName: "",
      Description: "",
      StatusID: "",
      proformaList: [],
      proformaDate: "",
      proformaInvoiceNo: "",
      Experience: "",
      isAccordionExpanded: false,
      currentPage: 1,
      application_no: ''
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem("AwardsUserLoginData") == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }

    setTimeout(() => {
      {
        sessionStorage.getItem("role_id") == 2 ? (
          this.props.navigate("/login")
        ) : <></>
      }
    }, 10);

    this.setState({
      user_id: sessionStorage.getItem("user_id") || "",
    });
    this.getProformaList();
  }

  getProformaList = () => {
    const { ApplicantName, proformaDate, proformaInvoiceNo, application_no } = this.state;
    this.setState({ isLoading: true });
    this.props.get_proformaList_action(
      ApplicantName != '' ? ApplicantName : null,
      proformaDate != '' ? moment(proformaDate).format('YYYY-MM-DD') : null,
      proformaInvoiceNo != '' ? proformaInvoiceNo : null,
      application_no != '' ? application_no : null,
    )
      .then((data) => {
        if (data.error !== 1) {
          this.setState({
            proformaList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          this.setState({ isLoading: false });
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  }

  navigateProformaAdd = () => {
    this.props.navigate("/juryProfileAU");
  }

  navigateProformaUpdate = (proforma_id) => {
    this.props.navigate(`/juryProfileAU`, {
      state: { proforma_id: proforma_id },
    });
  }

  clearFilters = () => {
    this.setState({
      ApplicantName: "",
      proformaDate: "",
      proformaInvoiceNo: "",
      application_no: ''
    }, () => {
      this.getProformaList();
    });
  }

  updateItem = (item) => {
    this.setState({ currentPage: item });
  }

  viewProforma(application_form_id, proforma_invoice_id) {
    this.setState({ isLoading: true })
    this.props
      .download_proforma_action(application_form_id, proforma_invoice_id)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false })
          // var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
          // var url = `${downloadReport}?SessionIdentifier=${data}`;
          // const win = window.location.replace(url, '_blank');
          const url = `${downloadReport}?SessionIdentifier=${data}`;
          window.open(url, "_blank", 'noopener,noreferrer');
        }
        else {
          this.setState({ isLoading: false })
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  proformaRecords(proformaList) {
    // const { userList } =this.state
    return (
      <table class="table table-bordered" id="dashboard-table">
        <thead>
          <tr >
            <th className="text-left"> Application No</th>
            <th className="text-left"> Proforma No</th>
            {role_id != 4 && <th style={{ width: "18%" }}>Applicant Name</th>}
            <th className="text-center">Proforma Date</th>
            <th className="text-center">Taxable Amount</th>
            <th className="text-center">CGST</th>
            <th className="text-center">SGST</th>
            <th className="text-center">IGST</th>
            <th className="text-center">Total Amount</th>
            {/* <th className="text-center">Outstanding</th> */}
            <th className="text-center" style={{ width: "5%" }}>

            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {proformaList?.length > 0 ? (
            proformaList.map((data) => (
              <tr>
                <td>{data.application_no}</td>
                <td>{data.proforma_invoice_no}</td>
                {role_id != 4 && <td>{data.applicant_name}</td>}
                <td className="text-center">{data.proforma_invoice_date != null ? moment(data.proforma_invoice_date).format("DD-MM-YYYY") : ""}</td>
                <td className="text-right">{data.taxable_amt != null ? data.taxable_amt.toLocaleString() : ''}</td>
                <td className="text-right">{data.cgst != null ? data.cgst.toLocaleString() : ''}</td>
                <td className="text-right">{data.sgst != null ? data.sgst.toLocaleString() : ''}</td>
                <td className="text-right">{data.igst != null ? data.igst.toLocaleString() : ''}</td>
                <td className="text-right">{data.grand_total != null ? data.grand_total.toLocaleString() : ''}</td>
                {/* <td className="text-right">{data.outstanding != null ? data.outstanding.toLocaleString() : ''}</td> */}
                {/* <td>{data.proformaInvoiceNo}</td> */}
                {/* <td>{data.is_active ? "Active" : "Inactive"}</td> */}

                <td className="text-center">
                  <img src="img/pdf-icon.png" height={20} width={18}
                    title="view"
                    className="btn btn-sm"
                    onClick={() => this.viewProforma(data.application_form_id, data.proforma_invoice_id)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <td colSpan={12} className="text-center">
              No records found
            </td>
          )}
        </tbody>
      </table>
    );
  }
  render() {
    const {
      isLoading,
      proformaList,
      currentPage,
      isAccordionExpanded,
      ApplicantName,
      proformaDate,
      proformaInvoiceNo,
      Experience,
      proforma_id,
      application_no
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = proformaList?.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(proformaList?.length / recordsPerPage);

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">

            <div className="website-view">
              <Header data={[8]} />
            </div>
            <div className="mobile-view">
              <MobileHeader data={[8]} />
            </div>
            <section class='header_margin_top'>
              <div className="container-fluid">
                <div className="page-header">
                  <h2 class="mb-3 dashboard-tit  py-0 blog-name blog-name-1">Proforma List</h2>
                  {/* <div onClick={() => this.navigateProformaAdd()}>
                        <i class="ri-add-box-line" style={{fontSize:"28px",cursor:'pointer'}}></i>
                    </div> */}
                </div>
                {role_id != 4 &&
                  <div className="search_accordion search_card">
                    <div className="panel-group" id="accordion">
                      <div className="panel panel-default">
                        <div
                          className="panel-heading accordion-toggle collapsed"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          data-target="#collapseOne"
                          aria-expanded={isAccordionExpanded}
                          onClick={() =>
                            this.setState({
                              isAccordionExpanded: !isAccordionExpanded,
                            })
                          }
                        >
                          <h4 className="panel-title">Search</h4>
                          <div className="searched_items">
                            {proformaInvoiceNo ? <>
                              <h5>
                                <b> Proforma No :</b> <span>{proformaInvoiceNo}</span>
                              </h5>
                            </> : <></>}
                            {ApplicantName ? <>
                              <h5>
                                <b>Applicant Name :</b> <span>{ApplicantName}</span>
                              </h5>
                            </> : <></>}
                            {proformaDate ? <>
                              <h5>
                                <b>Proforma Date :</b>  <span>{proformaDate != '' ? moment(proformaDate).format('DD-MM-YYYY') : ''}</span>
                              </h5>
                            </> : <></>}
                            {/* {Experience ? <>
                                <h5>
                                  <b>Experience :</b> <span>{Experience}</span>
                                </h5>
                              </> : <></>} */}
                          </div>
                        </div>
                        <div
                          id="collapseOne"
                          className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                            }`}
                        >
                          <div className="panel-body">
                            <div className="row mr_0 ml-1">
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Application No</label>
                                  <input
                                    type="text"
                                    className="form-control search_form_control"
                                    // placeholder="Enter application no"
                                    value={application_no}
                                    onChange={(e) =>
                                      this.setState({ application_no: e.target.value.replace(/\D/, '') })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label> Proforma No</label>
                                  <input
                                    type="text"
                                    className="form-control search_form_control"
                                    // placeholder="Enter proformaInvoice No"
                                    value={proformaInvoiceNo}
                                    onChange={(e) =>
                                      this.setState({ proformaInvoiceNo: e.target.value })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Applicant Name</label>
                                  <input
                                    type="text"
                                    className="form-control search_form_control"
                                    // placeholder="Enter Name"
                                    value={ApplicantName}
                                    onChange={(e) =>
                                      this.setState({ ApplicantName: e.target.value })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Proforma Date</label>
                                  <DatePicker className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                    selected={proformaDate}
                                    onChange={(date) => {
                                      this.setState({ proformaDate: date ? moment.utc(date).toDate() : '' })
                                    }}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText="DD/MM/YYYY"
                                  /> <div style={{ zIndex: '99' }} className="form-group d-flex" >
                                  </div>
                                </div>
                              </div>
                              {/* <div className="col-md-2">
                                  <div className="form-group">
                                    <label>Experience</label>
                                    <input
                                      type="text"
                                      className="form-control search_form_control"
                                      placeholder="Enter Experience"
                                      value={Experience}
                                      onChange={(e) =>
                                        this.setState({
                                          Experience: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div> */}

                              <div className="col-md-4">
                                <label>&nbsp;</label>
                                <button onClick={() => this.getProformaList()} className="btn btn-outline-primary search_btn mr-2">Search</button>
                                &nbsp;
                                <button onClick={this.clearFilters} className="btn btn-outline-danger clr_btn">Clear Filters</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}
                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                      {this.proformaRecords(currentRecords)}
                      {proformaList?.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <ToastContainer />
        </>
      </>
    );
  }
}
const mapDispatchToProps = { get_proformaList_action, insert_update_proforma_action, download_proforma_action };

export default withRouter(
  connect(null, mapDispatchToProps)(ProformaList)
);
